import { BookStatus } from 'core/enums';

export const displayStatus = (status: BookStatus): string => {
  if (status === BookStatus.SUBMITTED) return 'PENDING FOR PAYMENT';
  return status;
};
